import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import React, { FC, useState } from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';

interface ITwLocationsMenu {
  close?: () => void;
  menuOptions: { label: string; action: () => void; disabled: boolean; icon?: JSX.Element }[];
}

const TwLocationsDotsMenu: FC<ITwLocationsMenu> = ({ close, menuOptions }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  return (
    <>
      <IconButton
        disableRipple={true}
        className="contact-details__menu-icon"
        onClick={(event: React.MouseEvent<HTMLElement>): void => setAnchorEl(event.currentTarget)}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={(): void => {
          close && close();
          setAnchorEl(null);
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        className="contact-details__menu"
      >
        {menuOptions.map((option) => (
          <MenuItem key={option.label} disabled={option.disabled} onClick={option.action}>
            {option.label}
            {option.icon}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default TwLocationsDotsMenu;
